import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a86b6be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_title = _resolveComponent("ui-title")!
  const _component_TableHead = _resolveComponent("TableHead")!
  const _component_OrderItem = _resolveComponent("OrderItem")!
  const _component_ui_card = _resolveComponent("ui-card")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_ui_table = _resolveComponent("ui-table")!
  const _component_ui_container = _resolveComponent("ui-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_ui_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_ui_card, null, {
        title: _withCtx(() => [
          _createVNode(_component_ui_title, { title: "订单信息" })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_TableHead),
            _createVNode(_component_OrderItem, {
              modelValue: _ctx.formData,
              hidePayList: true
            }, null, 8, ["modelValue"])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_ui_card, null, {
        title: _withCtx(() => [
          _createVNode(_component_ui_title, { title: "付款单" })
        ]),
        default: _withCtx(() => [
          _withDirectives((_openBlock(), _createBlock(_component_ui_table, {
            data: _ctx.formData.payList
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                label: "ID",
                width: "100",
                prop: "id"
              }),
              _createVNode(_component_el_table_column, {
                label: "付款方式",
                width: "140"
              }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(_ctx.getPayTypeText(row.payType, row.payText)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "付款金额",
                width: "120"
              }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(row.amount), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "退款金额",
                width: "120"
              }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(row.returnAmount), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "支付状态",
                width: "110"
              }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(row.payStatus == 1 ? '已支付' : '未支付'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "交易号",
                "min-width": "200"
              }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(row.transactionId || '-'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "创建时间",
                width: "170"
              }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(_ctx.$format(row.createTime)), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])), [
            [_directive_loading, _ctx.loading]
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}